import isArray from "lodash/isArray";
import { collectionCardBgColors } from "../../../utils/constants";
import { CustomButton } from "./CustomButton";
import { StarFull } from "./Stars";
import { CollectionTrophy } from "./Trophy";

interface CollectionCardProps {
    index?: number;
    stars?: number;
    collection?: any;
    handlePlay: any;
}

const getBgColor = (i: number) => {
    if (
        !collectionCardBgColors ||
        !isArray(collectionCardBgColors) ||
        !collectionCardBgColors.length
    ) {
        return "bg-mint-cream";
    }
    if (i < collectionCardBgColors.length) {
        return collectionCardBgColors[i].bg;
    }
    return collectionCardBgColors[i % collectionCardBgColors.length].bg;
};

const getAcColor = (i: number) => {
    if (
        !collectionCardBgColors ||
        !isArray(collectionCardBgColors) ||
        !collectionCardBgColors.length
    ) {
        return "bg-eucalyptus";
    }
    if (i < collectionCardBgColors.length) {
        return collectionCardBgColors[i].ac;
    }
    return collectionCardBgColors[i % collectionCardBgColors.length].ac;
};

export const LevelCard: React.FC<CollectionCardProps> = ({
    index = 0,
    stars = 0,
    collection = {},
    handlePlay,
    totalQuestions,
    correctSubmissions,
}) => {
    return (
        <div
            className={
                "self-stretch px-3 py-4 mx-4 mt-8 shadow-collection rounded-2xl" +
                " " +
                getBgColor(index)
            }
        >
            <div className="flex flex-row">
                <div className="flex flex-col">
                    <span className="mb-2 mr-2 text-3xl font-semibold text-dark-purple">
                        {collection?.title}
                    </span>
                </div>
                <div className={" w-16 h-16 ml-auto"}>
                    <CollectionTrophy stars={stars} bottom="flat" />
                </div>
            </div>
            <div className="flex flex-col mb-11">
                <span className="mt-4 text-base font-light text-dark-purple">
                    {totalQuestions - correctSubmissions > 0
                        ? `Collect ${
                              correctSubmissions < 0
                                  ? totalQuestions
                                  : totalQuestions - correctSubmissions
                          } stars to complete level`
                        : `Level completed 🎉`}
                </span>
                <div className="h-1 mt-2 mb-4 bg-white rounded-lg w-i">
                    <div
                        style={{
                            width:
                                correctSubmissions > 0
                                    ? `${
                                          (correctSubmissions /
                                              totalQuestions) *
                                          100
                                      }%`
                                    : 0,
                        }}
                        className={
                            "h-full rounded-l-lg opacity-100" +
                            " " +
                            getAcColor(index)
                        }
                    ></div>
                </div>
                <div className="flex flex-row">
                    <span className="mr-2 text-2xl font-semibold text-dark-purple">
                        {correctSubmissions > 0 ? correctSubmissions : 0} /{" "}
                        {totalQuestions}
                    </span>
                    <div className="w-8 h-8 ">
                        <StarFull />
                    </div>
                </div>
            </div>
            <CustomButton
                cta={
                    correctSubmissions >= totalQuestions
                        ? "Replay"
                        : correctSubmissions > 0
                        ? "Complete Level"
                        : "Play"
                }
                type={"action"}
                onClick={() =>
                    handlePlay(
                        collection,
                        correctSubmissions > 0 &&
                            correctSubmissions < totalQuestions,
                    )
                }
            />
        </div>
    );
};
